import React, { useEffect, useState } from "react";
import { Box, Typography, Button, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedLayout } from "../../redux/slices/selectedLayoutSlice.js";
import LayoutSmallCardComponent from "./LayoutSmallCardComponent";

const LayoutItemList = ({ searchQuery }) => {
  const dispatch = useDispatch();

  const selectedLayout = useSelector(
    (state) => state?.selectedLayout?.selectedLayout
  );
  const playlistItems = useSelector(
    (state) => state.selectedLayout.selectedLayoutPlaylistItems
  );
  const dataToDisplay = useSelector(
    (state) => state.dataToDisplay.dataToDisplay
  );
  const dataMap = new Map(dataToDisplay?.map((data) => [data.id, data]));
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    setRefresh((prev) => !prev); 
  }, [selectedLayout]);

  if (!selectedLayout) {
    return <LayoutSmallCardComponent searchQuery={searchQuery} />;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-evenly",
        height: "auto",
        borderRadius: "8px",
        padding: "12px 20px",
        height: "auto",
        textAlign: "center",
        width:"100%"
      }}
    >
      <Typography variant="h6" fontWeight="bold" color="primary">
        Selected Layout: {selectedLayout?.name}
      </Typography>

      <Box
        sx={{
          mt: 2,
          width: "100%",
          height: "auto",
        }}
      >
        {playlistItems?.length > 0 ? (
          playlistItems.map((item) => {
            const matchedData = dataMap.get(item.content_ref);

            return (
              <Box
                key={item.id}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  padding: "10px",
                  width: "30vw",
                  borderBottom: "1px solid #ddd",
                }}
              >
                {item.type === "template" ? (
                  <iframe
                    srcDoc={
                      matchedData?.customProperties?.html ||
                      "<p>No HTML Found</p>"
                    }
                    style={{
                      width: "150px",
                      height: "100px",
                      border: "none",
                    }}
                    sandbox="allow-scripts allow-same-origin"
                  />
                ) : (
                  (() => {
                    const mediaUrl =
                      matchedData?.imageUrl ||
                      matchedData?.customisations?.[0]?.imageUrl ||
                      item?.imageUrl ||
                      item?.customisations?.[0]?.imageUrl;

                    if (!mediaUrl) return null;

                    const isVideo = /\.(mp4|webm|ogg)$/i.test(mediaUrl); 

                    return isVideo ? (
                      <video
                        src={mediaUrl}
                        controls
                        style={{
                          width: "150px",
                          height: "100px",
                          objectFit: "cover",
                          borderRadius: "5px",
                        }}
                      />
                    ) : (
                      <img
                        src={mediaUrl}
                        alt="content"
                        style={{
                          width: "150px",
                          height: "100px",
                          objectFit: "cover",
                          borderRadius: "5px",
                        }}
                      />
                    );
                  })()
                )}

                <Typography variant="body1">
                  {matchedData?.subtype || item.subtype}
                </Typography>
              </Box>
            );
          })
        ) : (
          <Typography>No items found in the playlist.</Typography>
        )}
      </Box>

      <div>
        <Typography variant="body2" color="textSecondary">
          Would you like to select a new layout?
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="small"
          sx={{ mt: 2, textTransform: "none" }}
          onClick={() => dispatch(setSelectedLayout(null))}
        >
          Select Another Layout
        </Button>
      </div>
    </Box>
  );
};

export default LayoutItemList;
